import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { CostReviewLineItemWithRecommendation } from '../cost-review-line-item-with-recommendation/cost-review-line-item-with-recommendation';

/**
 * @param {object} props
 * @param {boolean} props.isRecommendationSelected
 * @param {(recommendationKey: string) => void} props.onToggleRecommendation
 * @param {boolean} props.isToggleRecommendationDisabled
 * @param {import('../../../prop-types/cost-review.types').ShippingServiceCostReview} props.originalService
 * @param {import('../../../prop-types/cost-review.types').CostReviewShippingServiceRecommendation} props.shippingServiceRecommendation
 * @returns {React.JSX.Element}
 */
export const CostReviewLineItemShippingServiceWithRecommendation = ({
  isRecommendationSelected,
  onToggleRecommendation,
  originalService,
  shippingServiceRecommendation,
  isToggleRecommendationDisabled,
}) => {
  const recommendedService =
    useSelector((state) =>
      Global.selectSellerServiceById(state, {
        serviceId: shippingServiceRecommendation?.toServiceId,
      }),
    ) || {};

  const recommendation = useMemo(
    () => ({
      key: shippingServiceRecommendation.key,
      totalSavings: shippingServiceRecommendation.totalSavings,
      name: recommendedService.name,
      labelProviderId: recommendedService.labelProviderId,
    }),
    [
      shippingServiceRecommendation.key,
      shippingServiceRecommendation.totalSavings,
      recommendedService.labelProviderId,
      recommendedService.name,
    ],
  );

  return (
    <CostReviewLineItemWithRecommendation
      isRecommendationSelected={isRecommendationSelected}
      isToggleRecommendationDisabled={isToggleRecommendationDisabled}
      onToggleRecommendation={onToggleRecommendation}
      originalServiceCost={originalService.subTotal}
      originalServiceName={originalService.serviceName}
      recommendation={recommendation}
    />
  );
};
